<div class="d-flex align-center j-c h-100 opacity-7 fs-18 w-100 channeltext"
[ngStyle]="{
    'background-color': settingsData?.space_main_bg_color,
    'color': settingsData?.space_font_main_color
  }">
    Select a Space to start the conversation
</div>